import '@fontsource/atkinson-hyperlegible/400.css'
import '@fontsource/atkinson-hyperlegible/700.css'
import { TypographyVariantsOptions } from '@mui/material/styles'

const typography: TypographyVariantsOptions = {
  fontFamily: ['Atkinson Hyperlegible', 'sans-serif'].join(','),
  h1: { fontSize: 64 },
  h2: { fontSize: 48 },
  h3: { fontSize: 40 },
  h4: { fontSize: 32 }
}

export default typography
